import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import '../../styles/ConfirmTrainerRegistration.css';

const ConfirmTrainerRegistration = () => {
    const { trainerId } = useParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Potwierdzanie konta...');

    useEffect(() => {
        const confirmTrainerRegistration = async () => {
            try {
                await axios.put(`/api/v1/auth/confirm/${trainerId}`);
                setMessage('Poprawnie\npotwierdzono konto');
            } catch (error) {
                setMessage('Wystąpił błąd podczas potwierdzania konta.');
            }
        };

        confirmTrainerRegistration();
    }, [trainerId]);

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>{message}</h1>
                <button onClick={() => navigate('/')}>Zaloguj się</button>
            </div>
        </div>
    );
};

export default ConfirmTrainerRegistration;